import React, { useState, useEffect } from 'react';
import { DataGridPro, gridNumberComparator } from '@mui/x-data-grid-pro';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import './ListaInv.css';

function ListaInv(props) {
    var getBrowserWidth = function () {

        if (window.innerWidth < 1023) {
            return "xs";
        }
    };
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { code } = props;
    var [INV, setINV] = useState([]);
    var [filas, setFilas] = useState([]);
    const variablesAPedir = "id,idInverter,idCT,timeStamp,name,status,activePower,reactivePower,nominalPower,energyDay,productivity,cosPhi,temperature,vacR,vacS,vacT,iacR,iacS,iacT,energyTotal,energyMonth,energyYear";
    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/inverters?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataINV) => { setINV(await dataINV.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/inverters?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                    .then(async (dataINV) => { setINV(await dataINV.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number]);

    /*Tamaño para las columnas de la tabla y cuatas filas de alarmas queremos*/
    var anchoPantalla, columnasTabla, ocupadoPorcentaje, pixelesOcupados, pixelesRestantes, tamañoColum, tamañoSmall;
    var filas_inv;
    if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
        /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
        anchoPantalla = window.screen.width;
        columnasTabla = 13;
        ocupadoPorcentaje = 30;
        pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
        pixelesRestantes = anchoPantalla - pixelesOcupados;
        tamañoColum = parseInt(pixelesRestantes / columnasTabla, 10).toFixed(2);
        tamañoSmall = parseInt(tamañoColum - (tamañoColum * 0.195), 10);
        filas_inv = 14;
    } else {
        /*Tamaño para las columnas de la tabla, si es en movil o tablet*/
        anchoPantalla = window.screen.width;
        columnasTabla = 13;
        ocupadoPorcentaje = 30;
        pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
        pixelesRestantes = anchoPantalla - pixelesOcupados;
        tamañoColum = parseInt(pixelesRestantes / columnasTabla, 10).toFixed(2);
        tamañoSmall = parseInt(tamañoColum - (tamañoColum * 0.195), 10);
        filas_inv = 10;
    }

    /**Controlar el reajuste de tamaño de pantalla */
    window.addEventListener("resize", () => {
        if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
            //Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla 
            anchoPantalla = window.screen.width;
            columnasTabla = 13;
            ocupadoPorcentaje = 30;
            pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
            pixelesRestantes = anchoPantalla - pixelesOcupados;
            tamañoColum = parseInt(pixelesRestantes / columnasTabla, 10).toFixed(2);
            tamañoSmall = parseInt(tamañoColum - (tamañoColum * 0.195), 10);
            filas_inv = 14;
        } else {
            anchoPantalla = window.screen.width;
            columnasTabla = 13;
            ocupadoPorcentaje = 30;
            pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
            pixelesRestantes = anchoPantalla - pixelesOcupados;
            tamañoColum = parseInt(pixelesRestantes / columnasTabla, 10).toFixed(2);
            tamañoSmall = parseInt(tamañoColum - (tamañoColum / 0.195), 10);
            filas_inv = 10;
        }
    });
    var mobil = getBrowserWidth();

        const columnas = [
        { field: 'idCT', headerName: 'Id CT', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', cellClassName: 'celda-nombre', hide:true },
        { field: 'idInverter', headerName: 'Id Inverter', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', cellClassName: 'celda-timestamp', hide:true },
        { field: 'nombre', headerName: 'Nombre', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', cellClassName: 'celda-nombre' },
        { field: 'timeStamp', headerName: 'TimeStamp', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', cellClassName: 'celda-timestamp' },
        { field: 'status', headerName: 'Estado', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', cellClassName: 'celda-estado' },
        { field: 'activePower', headerName: 'Activa', width: tamañoSmall, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-activa' },
        { field: 'reactivePower', headerName: 'Reactiva', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-reactiva' },
        { field: 'nominalPower', headerName: 'Potencia', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-potencia' },
        { field: 'productivity', headerName: 'Productividad', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-productividad' },
        { field: 'cosPhi', headerName: 'cosPhi', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-cosPhi' },
        { field: 'temperature', headerName: 'Temp.', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-temp' },
        { field: 'vacR', headerName: 'vacR', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', hide: true, sortComparator: gridNumberComparator, cellClassName: 'celda-vacR' },
        { field: 'vacS', headerName: 'vacS', width:tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', hide: true, sortComparator: gridNumberComparator, cellClassName: 'celda-vacS' },
        { field: 'vacT', headerName: 'vacT', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', hide: true, sortComparator: gridNumberComparator, cellClassName: 'celda-vacT' },
        { field: 'iacR', headerName: 'iacR', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', hide: true, sortComparator: gridNumberComparator, cellClassName: 'celda-iacR' },
        { field: 'iacS', headerName: 'iacS', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', hide: true, sortComparator: gridNumberComparator, cellClassName: 'celda-iacS' },
        { field: 'iacT', headerName: 'iacT', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', hide: true, sortComparator: gridNumberComparator, cellClassName: 'celda-iacT' },
        { field: 'energyDay', headerName: 'E. Diaria', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-energia-diaria' },
        { field: 'energyTotal', headerName: 'E. Total', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-energia-total' },
        { field: 'energyMonth', headerName: 'E. Mensual', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-energia-mensual' },
        { field: 'energyYear', headerName: 'E. Anual', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', align: 'center', sortComparator: gridNumberComparator, cellClassName: 'celda-energia-anual' }];

    /*Mapeamos los datos. En la libreria de mui el contenido va como array de objetos, un objeto por fila */
    useEffect(() => {
        var array = [];
        INV.map((datoINV) => {
            const { id,idInverter,idCT, timeStamp, name, status, activePower, reactivePower, nominalPower, energyDay, productivity, cosPhi, temperature, vacR, vacS, vacT, iacR, iacS, iacT, energyTotal,
                energyMonth, energyYear } = datoINV;
            array.push({
                id: id, idCT:idCT,idInverter:idInverter, nombre: name, timeStamp: timeStamp, status: status, activePower: activePower, reactivePower: reactivePower,
                nominalPower: nominalPower, energyDay: energyDay, productivity: productivity, cosPhi: cosPhi, temperature: temperature, vacR: vacR, vacS: vacS, vacT: vacT, iacR: iacR, iacS: iacS, iacT: iacT,
                energyTotal: energyTotal, energyMonth: energyMonth, energyYear: energyYear
            });
        })
        setFilas(array);
    }, [INV]);
    if (mobil === "xs") {
        return (<div className='container-fluid' style={{width:'100%', padding:0, margin: 0}}>
            <div className='row' style={{padding: "0%",padding:0, margin: 0, width:'100%' }}>
                <div className='col-auto' id='div-table-inv-list' style={{padding:0, margin: 0, width:'100%'}}>
                    <DataGridPro
                        sx={{
                            width: '100%',
                            align: 'center',
                            ".MuiDataGrid-columnHeaders": { overflowX: 'scroll' },
                            ".MuiDataGrid-row": { display: 'block', width: '100%', paddingLeft: '0%', marginLeft: '0%' },
                            ".MuiDataGrid-virtualScrollerContent": { width: 'fit-content' },
                            ".MuiDataGrid-main": { overflow: 'none', },
                            ".MuiDataGrid-virtualScroller": { overflowX: 'hidden'},
                            ".MuiDataGrid-cell": { width: 'fit-content', border: 'none', position: 'relative', paddingLeft: '70%', marginTop: '.5%' },
                            ".MuiDataGrid-virtualScrollerRenderZone": { width: ' -webkit-fill-available' },
                            '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                            '& .comenzando': { backgroundColor: '#D0FF5B', fontWeight: 'bold', fontSize: '11px' },
                            '& .linea': { backgroundColor: '#11D428', fontWeight: 'bold', fontSize: '11px' },
                            '& .inactivo': { backgroundColor: '#e8b600', fontWeight: 'bold', fontSize: '11px' },
                            '& .apagado': { backgroundColor: '#FF5550', fontWeight: 'bold', color: 'white', fontSize: '11px' },
                            '& .sinirradiacion': { backgroundColor: '#1b6301', fontWeight: 'bold', color: 'white', fontSize: '11px' },
                            '& .fallocom': { backgroundColor: '#CACECE', fontWeight: 'bold', fontSize: '11px' },
                            '& .otros': { backgroundColor: '#0092ed', fontWeight: 'bold', fontSize: '11px', color: 'white' }
                        }}
                        rows={filas} columns={columnas} pagination pageSize={10} autoHeight={true}
                        /*pageSize es para cuantos registros queremos por pagina */
                        componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "Inversores" } } }}
                        components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick
                        getRowHeight={() => 'auto'} disableColumnResize='true'
                        onRowDoubleClick={(params) => window.open("/#/inv/" + (params.row.idCT) + "/" + (params.row.idInverter), "_self")}/*Acción de doble clic en la fila */
                        getCellClassName={(params) => {/*Dar estilo a las celdas */
                            if (params.field !== 'status' || params.value == null) {
                                return '';
                            }
                            if (params.field === 'status') {
                                if (params.value.includes("Sin irradiación")) {
                                    return 'sinirradiacion';
                                } else if (params.value.startsWith("Inactivo")) {
                                    return 'inactivo';
                                } else if (params.value.startsWith("En línea")) {
                                    return 'linea';
                                } else if (params.value === "Comenzando") {
                                    return 'comenzando';
                                } else if (params.value.startsWith("Apagado")) {
                                    return 'apagado';
                                } else if (params.value.startsWith("Fallo")) {
                                    return 'fallocom';
                                } else {
                                    return 'otros';
                                }
                            }
                        }}
                    />
                </div>
            </div>
        </div>)
    } else {
        return (
            <div className='container-fluid'>
                <div className='row' style={{ margin: "0%", padding: "0%" }}>
                    <div className='col-auto' id='div-table-inv-list'>
                        <DataGridPro
                            sx={{
                                width: '100%',
                                align: 'center',
                                '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' }, /*Definimos las clases para los estilos */
                                '& .comenzando': { backgroundColor: '#D0FF5B', fontWeight: 'bold', fontSize: '11px' },
                                '& .linea': { backgroundColor: '#11D428', fontWeight: 'bold', fontSize: '11px' },
                                '& .inactivo': { backgroundColor: '#e8b600', fontWeight: 'bold', fontSize: '11px' },
                                '& .apagado': { backgroundColor: '#FF5550', fontWeight: 'bold', color: 'white', fontSize: '11px' },
                                '& .sinirradiacion': { backgroundColor: '#1b6301', fontWeight: 'bold', color: 'white', fontSize: '11px' },
                                '& .fallocom': { backgroundColor: '#CACECE', fontWeight: 'bold', fontSize: '11px' },
                                '& .otros': { backgroundColor: '#0092ed', fontWeight: 'bold', fontSize: '11px', color: 'white' }
                            }}
                            rows={filas} columns={columnas} pagination pageSize={filas_inv} autoHeight={true} /*pageSize es para cuantos registros queremos por pagina */
                            componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "Inversores" } } }}
                            components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick
                            onRowDoubleClick={(params) => window.open("/#/inv/" + (params.row.idCT) + "/" + (params.row.idInverter), "_self")}/*Acción de doble clic en la fila */
                            getCellClassName={(params) => {/*Dar estilo a las celdas */
                                if (params.field !== 'status' || params.value == null) {
                                    return '';
                                }
                                if (params.field === 'status') {
                                    if (params.value.includes("Sin irradiación")) {
                                        return 'sinirradiacion';
                                    } else if (params.value.startsWith("Inactivo")) {
                                        return 'inactivo';
                                    } else if (params.value.startsWith("En línea")) {
                                        return 'linea';
                                    } else if (params.value === "Comenzando") {
                                        return 'comenzando';
                                    } else if (params.value.startsWith("Apagado")) {
                                        return 'apagado';
                                    } else if (params.value.startsWith("Fallo")) {
                                        return 'fallocom';
                                    } else {
                                        return 'otros';
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default ListaInv